import { useCallback } from 'react';
import { Tag } from 'antd';
import { PAYMENT_MODE_COLORS, PaymentMode } from '../constants';
import { PaymentModeIcon } from './PaymentModeIcon';

export const usePaymentModeRender = () => {
  return useCallback((mode: string) => {
    if (!mode) return '-';

    const paymentMode = mode as PaymentMode;
    const color = PAYMENT_MODE_COLORS[paymentMode] || 'default';

    return (
      <Tag
        color={color}
        icon={<PaymentModeIcon mode={paymentMode} />}
        style={{ fontWeight: 500 }}
      >
        {mode}
      </Tag>
    );
  }, []);
};
